package business

data class GoogleSheetsLeadConfig(
    val webhookUrl: String,
    val token: String,
) {
    fun isConfigured(): Boolean {
        return webhookUrl.isNotBlank() &&
            token.isNotBlank() &&
            !webhookUrl.startsWith(PLACEHOLDER_PREFIX) &&
            !token.startsWith(PLACEHOLDER_PREFIX)
    }

    private companion object {
        const val PLACEHOLDER_PREFIX = "REPLACE_WITH_"
    }
}

val googleSheetsLeadConfig = GoogleSheetsLeadConfig(
    webhookUrl = "https://script.google.com/macros/s/AKfycbxf3p6ze-1NHKqFYFShlAtqDiv7pnDW_KPrKAYjorlJz6W3jip6DyjNnD5v2GjqOPtmag/exec",
    token = "1WiSMsbELwR6rPQAw46sx242Ys8wP7AqyoKgPljuC0aTLNww1XPPtH2Pc1",
)
